import styled from "@emotion/styled";
import { colorPalette } from "../../../theme/colors";

// In MessageInput.styles.ts, update the StyledInput:

export const StyledInput = styled.textarea<{ keyboardType?: string }>`
  padding: 6.5px 8px;
  flex: 1 0 0;
  border-radius: 8px;
  border: 1px solid ${colorPalette.popWhite[200]};
  background: ${colorPalette.popWhite[500]};
  font-family: Lexend;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0.2px;
  color: ${colorPalette.popBlack[500]};
  min-height: 32px;
  max-height: 122px;
  height: 32px;
  outline: none;
  resize: none;
  overflow-x: hidden;
  overflow-y: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
  box-sizing: border-box;
  vertical-align: top;
  overflow-wrap: break-word;
  width: 100%;
  rows: 0;

  /* Android touch scrolling fix */
  touch-action: pan-y pan-x;
  -webkit-overflow-scrolling: touch;

  overscroll-behavior: contain;
  overscroll-behavior-y: contain;

  /* iOS Safari specific fixes */
  -webkit-appearance: none;
  appearance: none;
  -webkit-user-select: text;
  user-select: text;

  &::placeholder {
    color: ${colorPalette.popBlack[100]};
  }

  &:disabled {
    color: ${colorPalette.popBlack[100]};
    cursor: not-allowed;
  }

  /* Better iOS Safari handling */
  @supports (-webkit-touch-callout: none) {
    padding: 6.5px 8px;
    margin: 0;
    -webkit-appearance: none;
    appearance: none;
    -webkit-border-radius: 8px;
    border-radius: 8px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    height: 32px;
    min-height: 32px;
  }

  /* Force single line when empty */
  &:empty {
    height: 32px !important;
    min-height: 32px !important;
  }
`;

export const StyledQuill = styled.div`
  width: 100%;
  min-width: 0;
  max-width: 100%;
  .ql-container {
    border: 1px solid ${colorPalette.popBlack[100]};
    border-radius: 8px;
    min-height: 32px;
    max-height: 93px;
    overflow-y: hidden;
    width: 100%;
    max-width: 100%; /* Constrain width */
    font-family: Lexend;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 17px; /* 154.545% */
    letter-spacing: 0.2px;
    background-color: ${colorPalette.popWhite[500]};
    touch-action: pan-y pan-x;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    overscroll-behavior-y: contain;
  }
  .ql-editor {
    padding: 7.5px 8px 7.5px 8px;
    max-height: 93px;
    overflow-y: auto;
    color: ${colorPalette.popBlack[500]};
    line-height: 1.5;
    width: 100%;
    max-width: 100%; /* Constrain width */
    min-width: 0; /* Allow shrinking */
    white-space: pre-wrap;
    word-break: break-word;
    font-family: Lexend;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 17px; /* 154.545% */
    letter-spacing: 0.2px;
    touch-action: pan-y pan-x;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    overscroll-behavior-y: contain;
    &::placeholder {
      color: ${colorPalette.popBlack[100]};
    }
  }
  .ql-editor.ql-blank::before {
    font-size: 12px;
    font-weight: 400;
    color: ${colorPalette.popBlack[100]};
    font-style: normal;
    line-height: 17px;
    letter-spacing: 0.2px;
  }
  .ql-toolbar {
    display: none; /*Hide default toolbar*/
  }
  .quill {
    min-width: 0;
    width: 100%;
    max-width: 100%; /* Constrain width */
  }
`;

export const ToolbarSeparator = styled.div`
  text-align: center;
  font-size: 22px;
  font-style: normal;
  font-weight: 900;
  line-height: 18px; /* 81.818% */
  letter-spacing: 0.2px;
  color: ${colorPalette.popBlack[100]};
`;
